import React, { useState } from "react";
import { FiX } from "react-icons/fi";

const ConsultationModal = ({ isOpen, onClose }) => {
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "ac2e9cee-6cba-4036-ba57-56c081ef5ea8");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully ✅");
        event.target.reset();

        // Auto close after 2 sec
        setTimeout(() => {
          onClose();
          setResult("");
        }, 2000);
      } else {
        setResult("Something went wrong ❌");
      }
    } catch (error) {
      setResult("Submission failed ❌");
    }

    setLoading(false);
  };

  return (
    <div
      className="fixed inset-0 mt-8 z-50 bg-black/60 flex justify-center overflow-y-auto px-4"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-3xl rounded-2xl shadow-2xl relative my-8 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center border-b px-4 md:px-6 py-4">
          <h2 className="text-base md:text-xl font-serif text-red-600">
            Get a Free Consultation from Wedding Stays
          </h2>

          <FiX
            className="text-2xl cursor-pointer text-gray-500 hover:text-black"
            onClick={onClose}
          />
        </div>

        {/* Body */}
        <div className="p-4 md:p-8">
          <h3 className="text-center text-gray-700 mb-6 md:mb-8 text-sm md:text-base">
            Please Enter Your Wedding Details To Continue
          </h3>

          <form
            onSubmit={onSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6"
          >
            <input
              type="text"
              name="name"
              placeholder="Name *"
              required
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400"
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400"
            />

            <input
              type="tel"
              name="phone"
              placeholder="Mobile No. *"
              required
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400 md:col-span-2"
            />

            <input
              type="text"
              name="wedding_month"
              placeholder="Wedding Month *"
              required
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400"
            />

            <input
              type="text"
              name="city"
              placeholder="Wedding City *"
              required
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400"
            />

            <input
              type="number"
              name="guests"
              placeholder="Number of Guests *"
              required
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400"
            />

            <input
              type="text"
              name="couple_name"
              placeholder="Couple Name"
              className="rounded-full border px-4 py-3 outline-none focus:ring-2 focus:ring-red-400"
            />

            {/* Submit Button */}
            <div className="md:col-span-2 flex flex-col items-center mt-4">
              <button
                type="submit"
                disabled={loading}
                className="bg-[#b76d68] text-white 
                           px-8 py-3 rounded-md shadow-lg 
                           transition duration-300 
                           disabled:opacity-60"
              >
                {loading ? "Please Wait..." : "Get A Free Quote"}
              </button>

              {result && (
                <p className="mt-4 text-sm text-green-600 text-center">
                  {result}
                </p>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConsultationModal;
